import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';
import Stay from './pages/Stay';
import Rates from './pages/Rates';
import Gallery from './pages/Gallery';
import Location from './pages/Location';
import Contact from './pages/Contact';
import BookingConfirmation from './pages/BookingConfirmation';
import LocalFinds from './pages/LocalFinds';
import ScenicViews from './pages/ScenicViews';
import PahiyasSpirit from './pages/PahiyasSpirit';
import WarmWelcome from './pages/WarmWelcome';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import NotFound from './pages/NotFound';
import Login from './pages/Admin/Login';
import Dashboard from './pages/Admin/Dashboard';
import ApiDocs from './pages/Admin/ApiDocs';
import IcalSync from './pages/Admin/IcalSync';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Admin Routes */}
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin" element={<Dashboard />} />
        <Route path="/admin/api-docs" element={<ApiDocs />} />
        <Route path="/admin/ical-sync" element={<IcalSync />} />

        {/* Public Routes with MainLayout */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/stay" element={<Stay />} />
          <Route path="/rates" element={<Rates />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/location" element={<Location />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booking-confirmation" element={<BookingConfirmation />} />
          <Route path="/local-finds" element={<LocalFinds />} />
          <Route path="/scenic-views" element={<ScenicViews />} />
          <Route path="/pahiyas-spirit" element={<PahiyasSpirit />} />
          <Route path="/warm-welcome" element={<WarmWelcome />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Route>

        {/* 404 Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;